
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31.705","height":"31.705","data-name":"Group 138","viewBox":"0 0 31.705 31.705"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-2",attrs:{"d":"M13.438 25.435h3.859v-9.663h2.693l.287-3.236h-2.98v-1.842c0-.763.154-1.064.891-1.064h2.088V6.271h-2.672c-2.871 0-4.166 1.265-4.166 3.685v2.58H11.43v3.276h2.008z","data-name":"Path 821","fill":"#fff"}})])
          )
        }
      }
    